import {API_URL, apiPut} from '../api'
import {ApiRes} from '../../types/api'
import {IAnnouncement} from './getAnnounceList'

export const postEditAnnounce = async (data: IAnnouncement): Promise<ApiRes<IAnnouncement>> => {
    return await apiPut(API_URL, `official/post/edit`, data)
}
